export class AstraBookingFilter {
    constructor() {
        // Cache DOM elements for reuse
        this.cacheDOM();
       
        

        // Variable to track the currently active dropdown
        this.activeDropdown = null;

        // Bind event listeners
        this.bindEvents();
    }

    // Method to cache frequently accessed DOM elements
    cacheDOM() {
        this.doctorFilterContainer = document.getElementById('doctorFilter');
        this.monthFilterContainer = document.getElementById('monthFilter');
        this.filterButton = document.getElementById('filterButton');
        this.doctorValue = document.getElementById('doctorValue');
        this.monthValue = document.getElementById('monthValue');

       
    }

    // Method to bind event listeners to relevant elements
    bindEvents() {
        // Handle clicks on the doctor filter container
        this.doctorFilterContainer.addEventListener('click', this.handleFilterClick.bind(this));

        // Handle clicks on the month filter container
        this.monthFilterContainer.addEventListener('click', this.handleFilterClick.bind(this));

        // Handle clicks on the filter button to trigger filtering
        this.filterButton.addEventListener('click', this.filterResults.bind(this));
    }

    // Event handler for filter clicks
    handleFilterClick(event) {

      
        
        // If the click is inside an open dropdown, ignore it
        if (event.target.closest('.booking-dropdown')) return;
      
        // Identify the clicked filter element
        const target = event.target.closest('.custom-filter');

      
        
        if (!target) return; // Exit if no valid filter element is found


        // Find the dropdown within the clicked filter
        let dropDownID = target.dataset.filter;
         
        console.log(dropDownID);
        
        const dropdown = document.querySelector(`#${dropDownID}`);
        

   
        
 
 
        

        // Toggle the dropdown visibility
        this.toggleDropdown(dropdown);
    }

    // Method to handle dropdown toggling logic
    toggleDropdown(dropdown) {
        // Close the currently active dropdown if it's not the one being clicked
        if (this.activeDropdown && this.activeDropdown !== dropdown) {
            this.activeDropdown.classList.remove('active');
        }

        // Toggle the dropdown passed as an argument and set it as the active one
        if (dropdown) {
            this.activeDropdown = dropdown;
            this.activeDropdown.classList.toggle('active');
        }
    }

    // Method to handle the filtering logic when the filter button is clicked
    filterResults() {

      // Get service_parent and service_id from the URL
const urlParams = new URLSearchParams(window.location.search);
const service_parent = urlParams.get('service_parent');
const service_id = urlParams.get('service_id');
const month = this.monthValue.value;
const doctor = this.doctorValue.value;

// Create an object to store query parameters
const params = {};

// Add parameters conditionally
if (service_parent) params.service_parent = service_parent;
if (service_id) params.service_id = service_id;
if (month) params.date = month;
if (doctor) params.doctor = doctor;

// Use URLSearchParams to convert the object to a query string
const queryString = new URLSearchParams(params).toString();

 window.location.href = `/booking-service/?${queryString}`;
        
        
    }
}